import { default as JobCherryPickingPage } from './job-cherry-picking/job-cherry-picking'
import { default as ApplicantsReviewPage } from './applicants-review/applicants-review'
import { default as ApplicantDetailsPage } from './applicant-details/applicant-details'

export const ApplicantsReviewStack = {
  ApplicantsReviewPage,
  JobCherryPickingPage,
  ApplicantDetailsPage,
}
